export enum MasterAccountApplicationStepOrdersEnum {
	SELECT_COUNTERPARTY_STEP_ORDER = "SELECT_COUNTERPARTY_STEP_ORDER",
	CONTACT_INFORMATION_STEP_ORDER = "CONTACT_INFORMATION_STEP_ORDER",
	SELECT_BRANCH_STEP_ORDER = "SELECT_BRANCH_STEP_ORDER",
	SIGN_APPLICATION_STEP_ORDER = "SIGN_APPLICATION_STEP_ORDER",
	DOCUMENTS_STEP_ORDER = "DOCUMENTS_STEP_ORDER",
	FINAL_STEP_ORDER = "FINAL_STEP_ORDER"
}
